import { getCurrentInstance } from 'vue';

export default function useStatusDropdownOptions() {
  const _this = getCurrentInstance()?.proxy as any;
  if (!_this) return;

  const statusDropdownOptions = (defaultStatuses: any, statuses: any) => {
    return Object.keys(defaultStatuses)
      .map((key: any) => {
        const cardStatus = defaultStatuses[key] ?? {};
        if (cardStatus.id !== _this.$constants.rolledOverList) {
          return {
            ...cardStatus,
            customIcon: cardStatus.icon,
            customIconColor: cardStatus.color,
            key: cardStatus.key,
            id: cardStatus.id,
            label: cardStatus.label,
            checkbox: true,
            checked: statuses?.includes?.(cardStatus.id),
            lighter: true,
            strong: true,
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  return {
    statusDropdownOptions,
  };
}
